import type { Session } from "@supabase/supabase-js";

import type { LegalDocumentType } from "@tinkr/shared/legal";

import { idempotencyKey, tinkrApiFetch } from "./client";

export type LegalDocumentStatus = {
  documentType: LegalDocumentType;
  version: string;
  title: string;
  summaryOfChanges: string | null;
  effectiveAt: string;
  acceptedAt: string | null;
  requiresAcceptance: boolean;
};

export type LegalStatusResponse = {
  ok: true;
  documents: LegalDocumentStatus[];
  requiresAcceptance: boolean;
};

export type LegalAcceptanceSource = "signup" | "login_gate";

export type RecordLegalAcceptancesInput = {
  acceptances: { documentType: LegalDocumentType; version: string }[];
  source: LegalAcceptanceSource;
};

export function getLegalStatus(session: Session): Promise<LegalStatusResponse> {
  return tinkrApiFetch<LegalStatusResponse>(session, "/v1/account/legal-status");
}

export function recordLegalAcceptances(
  session: Session,
  input: RecordLegalAcceptancesInput
): Promise<LegalStatusResponse> {
  return tinkrApiFetch<LegalStatusResponse>(session, "/v1/account/legal-acceptances", {
    method: "POST",
    headers: { "idempotency-key": idempotencyKey("legal-accept") },
    body: JSON.stringify(input)
  });
}
